import t from "./generateUtilityClasses.mjs";
import s from "./generateUtilityClass.mjs";
function r(e) {
  return s("MuiMenuItem", e);
}
const i = t("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), u = i;
export {
  u as default,
  r as getMenuItemUtilityClass
};
//# sourceMappingURL=menuItemClasses.mjs.map
